import {useSelector} from 'react-redux';

import experienceScoreStatuses from '@/consts/experienceScore/experienceScoreStatuses';
import rangeModeTipMapping from '@/services/experienceScore/mappings/rangeModeTipMapping';
import tipsToConsiderMapping from '@/services/experienceScore/mappings/tipsToConsiderMapping';
import {selectExperienceInsightsAndTips, selectExperienceTipsToConsider} from '@/state/selectors/inference';
import {selectIsRangeModeEnabled} from '@/state/selectors/insights';
import type {TipData} from '@/types/experienceScore';

const useTipsToConsider = (): TipData[] => {
    const {optimal = [], sub_optimal = []} = useSelector(selectExperienceTipsToConsider) ?? {};
    const insightsAndTips = useSelector(selectExperienceInsightsAndTips);
    const isRangeModeEnabled = useSelector(selectIsRangeModeEnabled);

    const mapTipsData = (insightIds: string[], status: string): TipData[] =>
        insightIds
            .map((insightId) => tipsToConsiderMapping.getTipsToConsiderByStatus({insightId, status, insightsAndTips}))
            .filter(({description}) => Boolean(description));

    const subOptimalTips = mapTipsData(sub_optimal, experienceScoreStatuses.SUB_OPTIMAL);

    // Warnings win, but without authored warning copy the success tips still fill the section.
    if (subOptimalTips.length > 0) return subOptimalTips;

    const bucketTips = mapTipsData(optimal, experienceScoreStatuses.OPTIMAL);

    const rangeModeRecommendation = rangeModeTipMapping.getRecommendationTip({insightsAndTips, isRangeModeEnabled});

    return rangeModeRecommendation ? [...bucketTips, rangeModeRecommendation] : bucketTips;
};

export default useTipsToConsider;
